module.exports = __webpack_public_path__ + "img/activity-tracker-logo.d41a61c4.png";